import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom';
import Profile from './components/Profile';
import SiteHeader from './components/SiteHeader';
import { GetGemdropButton } from './components/GetGemdropButton';
import OfferWall from './components/OfferWall';
import AppDetails from './components/AppDetails';
import './App.css';

function App() {
  // Determine mode based on subdomain
  const hostname = window.location.hostname;
  const isPreview = hostname.startsWith('preview.');
  const isLive = hostname.startsWith('link.');
  const isTest = hostname.startsWith('test.');

  // For local development, we'll check the subdomain
  const mode = isTest ? 'test' : (isPreview ? 'preview' : 'live');
  
  // State to control whether to show the Gemdrop button and user ID
  const [showGemdropButton, setShowGemdropButton] = useState(false);
  const [userId, setUserId] = useState<string | undefined>(undefined);

  // Render different content based on mode
  if (mode === 'test') {
    return (
      <Router>
        <div className="App">
          <Routes>
            <Route path="/app/:appId" element={<AppDetails />} />
            <Route path="/:username" element={<OfferWall userId={undefined} />} />
            <Route path="/" element={<OfferWall userId={undefined} />} />
          </Routes>
        </div>
      </Router>
    );
  }

  // Original functionality for preview and live modes
  return (
    <Router>
      <div className="App">
        <SiteHeader mode={mode as 'preview' | 'live'} />
        <Routes>
          <Route path="/:username" element={<Profile mode={mode as 'preview' | 'live'} onProfileLoad={(showButton, id, hasOffers) => {
            // Only show button if profile has it enabled AND there are offers to display
            setShowGemdropButton(showButton && hasOffers === true);
            setUserId(id);
          }} />} />
          <Route path="/" element={<HomePage />} />
        </Routes>
        {showGemdropButton && <GetGemdropButton userId={userId} />}
      </div>
    </Router>
  );
}

function HomePage() {
  return (
    <div className="home-page">
      <h1>GoTap Link in Bio</h1>
      <p>Add your username to the URL to view a profile</p>
      <p>Example: /johndoe</p>
    </div>
  );
}

export default App;